// dwaar/src/lib/supabaseClient.js
// Repo: terralekha-core | Folder: dwaar/src/lib/
// Dwaar — Supabase browser client factory.
//
// Used by Saakshi (callback) to exchange the magic-link token for a session.
// Uses the ANON key only — never the service role key in client code.
//
// detectSessionInUrl is false: Saakshi handles the URL fragment / code exchange
// explicitly so we can surface loading/success/error states deterministically.

import { createClient } from "@supabase/supabase-js";

let _client = null;

export function getSupabaseClient() {
  if (_client) return _client;

  const url = import.meta.env.VITE_SUPABASE_URL;
  const anonKey = import.meta.env.VITE_SUPABASE_ANON_KEY;

  if (!url || !anonKey) {
    throw new Error("Supabase client is not configured.");
  }

  // detectSessionInUrl is false: Saakshi handles the token exchange itself so
  // loading / success / error states stay deterministic.
  // flowType is left at the library default (implicit) because magic links in
  // Pravesh are generated server-side via admin.generate_link — the PKCE code
  // verifier would not be available in this browser session.
  _client = createClient(url, anonKey, {
    auth: {
      persistSession: true,
      autoRefreshToken: true,
      detectSessionInUrl: false,
    },
  });
  return _client;
}

// Test-only hook — allows tests to inject a fake client and reset state.
export function __setSupabaseClientForTesting(fake) {
  _client = fake;
}
